import { Flex, Typography } from 'antd';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { FC } from 'react';
import styles from './BoatsMenu.module.scss';
import { SectionItemProps } from './BoatsMenu.props';

const { Title } = Typography;

const SectionItem: FC<SectionItemProps> = ({ title, items, path }) => (
  <>
    <Title level={3} className={styles.sectionTitle} ellipsis={{ rows: 1 }}>
      {title}
    </Title>
    <>
      {items.length && (
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              <Link href={`/boats${path}${item.path}`} title={item.title}>
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
    <Link href={`/boats${path}`} className={styles.viewAllLink} title={title}>
      <Flex align="center">
        <span>View all</span>
        <ChevronRight size={18} />
      </Flex>
    </Link>
  </>
);

export default SectionItem;
